import type { CSSProperties } from 'react'
import { getNewsCategoryConfig } from './newsCategoryConfig'

export function CategoryBadge({ category }: { category?: string }) {
  const config = getNewsCategoryConfig(category)
  const Icon = config.icon
  return <span className="news-category-badge" style={{ '--news-tone': config.color } as CSSProperties}>
    <span className="news-category-badge__icon"><Icon size={32} strokeWidth={1.55} aria-hidden="true"/></span>
    <span><small>SYSTEM LAYER</small><strong>{config.label}</strong></span>
  </span>
}
